import { NgModule, LOCALE_ID } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";

import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HomeComponent } from "./pages/home/home.component";
import { BenefitComponent } from "./pages/benefit/benefit.component";
import { FaqComponent } from "./pages/faq/faq.component";
import { BlogComponent } from "./pages/blog/blog.component";
import { BlogExportComponent } from "./pages/blog/blog-export/blog-export.component";
import { BlogVideoFormatComponent } from "./pages/blog/blog-video-format/blog-video-format.component";
import { BlogReadDirectoryComponent } from "./pages/blog/blog-read-directory/blog-read-directory.component";
import { BlogV240Component } from "./pages/blog/blog-v240/blog-v240.component";
import { PrivacyComponent } from "./pages/privacy/privacy.component";
import { ImprintComponent } from "./pages/imprint/imprint.component";
import { FunctionsComponent } from "./pages/functions/functions.component";
import { ContactComponent } from "./pages/contact/contact.component";
import { FunctionArchiveComponent } from "./pages/function-archive/function-archive.component";
import { TrainingComponent } from "./pages/training/training.component";
import { DownloadComponent } from "./pages/download/download.component";
import { UtilityFilmDefinitionComponent } from "./pages/utility-film-definition/utility-film-definition.component";
import { ReasonsComponent } from "./pages/reasons/reasons.component";
import { ModalComponent } from "./directives/modal/modal.component";
import { MatLegacyButtonModule as MatButtonModule } from "@angular/material/legacy-button";
import { MatLegacyDialogModule as MatDialogModule } from "@angular/material/legacy-dialog";

import { ModalService } from "./services/modal.service";
import { ErrorComponent } from "./error/error/error.component";
import { InvalidDownloadComponent } from "./error/invalid-download/invalid-download.component";
import { ServerErrorComponent } from "./error/server-error/server-error.component";
import { ImageTickerComponent } from "./components/image-ticker/image-ticker.component";
import { VideoDialogComponent } from "./components/video-dialog/video-dialog.component";
import { VideoComponent } from "./pages/video/video.component";
import { LearningComponent } from "./pages/promotion/learning/learning.component";
import { ClipNumberComponent } from "./pages/blog/clip-number/clip-number.component";
import { UsingMetadataComponent } from "./pages/blog/using-metadata/using-metadata.component";
import { UsingSourcesComponent } from "./pages/blog/using-sources/using-sources.component";
import { ImageLibraryComponent } from "./pages/blog/image-library/image-library.component";
import { BlogBroseComponent } from "./pages/blog/blog-brose/blog-brose.component";
import { BlogSwitchLangComponent } from "./pages/blog/blog-switch-lang/blog-switch-lang.component";
import { BlogVersioningComponent } from "./pages/blog/blog-versioning/blog-versioning.component";
import { BlogImportComponent } from "./pages/blog/blog-import/blog-import.component";
import { BlogFramenavigationComponent } from "./pages/blog/blog-framenavigation/blog-framenavigation.component";
import { BlogScriptactionComponent } from "./pages/blog/blog-scriptaction/blog-scriptaction.component";
import { BlogVersion23Component } from "./pages/blog/blog-version23/blog-version23.component";
import { TranslocoRootModule } from "./transloco-root.module";
import { WebinarComponent } from "./pages/webinar/webinar.component";
import { registerLocaleData } from "@angular/common";
import localeDe from "@angular/common/locales/de";
import { BlogV250Component } from "./pages/blog/blog-v250/blog-v250.component";
import { BlogV260Component } from "./pages/blog/blog-v260/blog-v260.component";

registerLocaleData(localeDe);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    BenefitComponent,
    FaqComponent,
    BlogComponent,
    BlogExportComponent,
    BlogVideoFormatComponent,
    BlogReadDirectoryComponent,
    BlogV240Component,
    BlogV250Component,
    BlogV260Component,
    PrivacyComponent,
    ImprintComponent,
    FunctionsComponent,
    ContactComponent,
    FunctionArchiveComponent,
    TrainingComponent,
    DownloadComponent,
    UtilityFilmDefinitionComponent,
    ReasonsComponent,
    ModalComponent,
    ErrorComponent,
    InvalidDownloadComponent,
    ServerErrorComponent,
    ImageTickerComponent,
    VideoDialogComponent,
    VideoComponent,
    LearningComponent,
    ClipNumberComponent,
    UsingMetadataComponent,
    UsingSourcesComponent,
    ImageLibraryComponent,
    BlogBroseComponent,
    BlogSwitchLangComponent,
    BlogVersioningComponent,
    BlogImportComponent,
    BlogFramenavigationComponent,
    BlogScriptactionComponent,
    BlogVersion23Component,
    WebinarComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    MatDialogModule,
    MatButtonModule,
    AppRoutingModule,
    HttpClientModule,
    TranslocoRootModule,
  ],
  providers: [ModalService, { provide: LOCALE_ID, useValue: "de" }],
  bootstrap: [AppComponent],
})
export class AppModule {}
